import classNames from 'classnames';
import * as df from 'date-fns';
import * as React from 'react';
import { useIntl } from 'react-intl';
import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';
import { OutlineLabel } from '../../../../../../../atoms/OutlineLabel';

import css from './BooksDateTimePicker.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  postable: boolean;
  checked: boolean;
  date: string;
  startTime: string;
  endTime: string;
  onChange: (e: React.ChangeEvent) => void;
  vacancy: number;
  showVacancy: boolean;
  attendees: number;
  waitingListProvided: boolean;
  setNotification?: boolean;
  onClickSetNotification?: (e: React.MouseEvent) => void;
}

const BooksDateTimePicker = ({
  postable,
  checked,
  date,
  startTime,
  endTime,
  onChange,
  value,
  vacancy,
  showVacancy,
  attendees,
  waitingListProvided,
  setNotification,
  onClickSetNotification,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(css.BooksDateTimePicker);
  const dateClasses = classNames(
    css.BooksDateTimePicker__Date,
    vacancy < attendees || vacancy < 1 ? css.isDisabled : '',
  );
  const notificationClasses = classNames(
    css.BooksDateTimePicker__Notification,
    css.isSetNotification,
  );
  const labelClasses = classNames(css.BooksDateTimePicker__Label, {
    [css.isSoldOut]: !vacancy,
  });

  return (
    <div className={classes}>
      <CheckInput
        value={value}
        type={InputType.Checkbox}
        checked={checked}
        name="books-date-time-picker"
        onChange={onChange}
        labelPosition="FlexWrap"
        disabled={vacancy < attendees || vacancy < 1}
      >
        <div className={dateClasses}>
          {intl.formatDate(df.format(date), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
          })}
          <span className={css.BooksDateTimePicker__Time}>
            {startTime}
            <span> - </span>
            {endTime}
          </span>
        </div>
        <div className={css.BooksDateTimePicker__Labels}>
          {vacancy > attendees ? (
            showVacancy && (
              <OutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksDateTimePicker__Label}
              />
            )
          ) : vacancy < 1 ? (
            <OutlineLabel
              label={intl.formatMessage({
                id: 'merchants.services.status.soldOut',
              })}
              className={labelClasses}
            />
          ) : (
            showVacancy && (
              <OutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksDateTimePicker__Label}
              />
            )
          )}
          {setNotification
            ? vacancy < 1 &&
              waitingListProvided && (
                <span className={notificationClasses}>
                  {intl.formatMessage({
                    id: 'books.notification.notificationSet',
                  })}
                </span>
              )
            : vacancy < 1 &&
              waitingListProvided && (
                <button
                  type="button"
                  value={value}
                  disabled={!postable}
                  className={css.BooksDateTimePicker__Notification}
                  onClick={onClickSetNotification}
                >
                  {intl.formatMessage({ id: 'books.notification.getNotified' })}
                  {!postable && (
                    <span className={css.BooksDateTimePicker__Loading} />
                  )}
                </button>
              )}
        </div>
      </CheckInput>
    </div>
  );
};

export default BooksDateTimePicker;
